
import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'

const PricebannerConfirmExitModal = ({
  isOpen,
  onClose,
  onConfirm,
  translate
}) => (
  <Modal
    isOpen={isOpen}
    onCloseModal={onClose}
    showHeader={false}
    showFooter={false}
    center
    className="pricebanner-confirm-exit-modal"
    showCloseModal={false}
  >
    <div>
      <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '12px' }}>
        {(translate('out.without.save'))}
      </h2>

      <p style={{ fontSize: '16px', marginBottom: '24px', color: '#000000' }}>
        {(translate('out.without.save.msg.1'))}
        <br />
        <br />
        {(translate('price.banner.out.without.save.msg'))}
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '50px' }}>
        <button
          onClick={onClose}
          style={{
            border: 'none',
            fontWeight: '600',
            color: '##3C3738',
            backgroundColor: '#fff',
            cursor: 'pointer'
          }}
        >
          {(translate('button.cancel'))}
        </button>

        <button
          onClick={onConfirm}
          style={{
            backgroundColor: '#B42A27',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          {(translate('out.without.save.confirm'))}
        </button>
      </div>
    </div>
  </Modal>
)

PricebannerConfirmExitModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default PricebannerConfirmExitModal